'use client';

import React from 'react';
import Dialog from '@ui/Dialog';
import Typography from '@ui/Typography';
import { ScrollArea } from '@ui/ScrollArea';
import Image from 'next/image';
import useInfoModalStore from '@/components/store/infoModalSlice';
import getQualifiedImageUrl from '@/utils/imageUrlProcessor';

function InfoPopUp() {
  const { open, logoUrl, title, name, description, closeModal } =
    useInfoModalStore();

  if (!open) return null;

  const dialogTitle = title || 'Information';

  return (
    <Dialog
      // title={dialogTitle}
      isOpen={open}
      onClose={closeModal}
      maxWidth="sm">
      <ScrollArea className="w-full flex-1">
        <div className="flex flex-col items-center gap-2">
          {/* Logo / Icon */}
          {logoUrl && (
            <div className="flex items-center justify-center overflow-hidden rounded-full bg-gray-50 shadow-sm">
              <Image
                src={getQualifiedImageUrl(logoUrl)}
                alt={name || title || 'info-logo'}
                width={64}
                height={64}
                className="object-contain"
              />
            </div>
          )}

          {/* Name */}
          {name && (
            <Typography variant="h4" className="mt-2 text-center font-semibold">
              {name}
            </Typography>
          )}

          {/* Description — left-aligned */}
          {description && (
            <Typography
              variant="body1"
              className="mt-2 max-w-md text-left leading-relaxed text-text-secondary">
              {description}
            </Typography>
          )}
        </div>
      </ScrollArea>
    </Dialog>
  );
}

export default InfoPopUp;
